import find from 'lodash/find'
import { useError, useHistory } from '@ztechapps/common.hook'

export const useReportActions = ({ reportTemplateCategories }): any => {
  const history = useHistory()
  const { onError } = useError()

  return async ({ category, _id }: Record<string, any> = {}) => {
    try {
      if (!category) {
        return
      }
      const found = find(reportTemplateCategories, { name: category })

      if (!found) throw new Error('Cannot find the category from the list')

      history.push(found?.route?.altPath({ templateId: _id }))
    } catch (e) {
      onError(e)
    }
  }
}
